import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { fetchImagesByProjectId } from './imagesByProjectIdSlice';

// Create an async thunk for removing plan
export const removePlan = createAsyncThunk('plan/removePlan', async (planId, { dispatch }) => {
    try {
      const response = await fetch(`/api/plans/${planId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      // Fetch images after image removal
      // dispatch(fetchImagesByProjectId(projectId));
      return data; 
    } catch (error) {
      console.error('Error removing plan:', error);
      throw error; // Propagate the error
    }
  }
);

const removePlanSlice = createSlice({
  name: 'plan',
  initialState: { status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(removePlan.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(removePlan.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(removePlan.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default removePlanSlice.reducer;